module.exports = __webpack_public_path__ + "img/thumbnail_WildWaterBuffalo_j_normal.cdf281ea.png";